module.exports = __webpack_public_path__ + "img/hero.d6931b85.jpeg";